import { ShiftBottomSheetBookabilityCriteriaCard } from "../../BottomSheet/BookabilityCriteriaCard";

export function BundleFailedLoadingCard() {
  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="error"
      title="Some shifts are no longer available"
      description="Apologies for the inconvenience. Try reloading to see the latest availability."
      illustrationType="error"
    />
  );
}
